module.exports = __webpack_public_path__ + "static/WEDDING E&M-156-bc6ee1d882d3a29a4f951cdaca562f06.jpg";